// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__1YGqq","modal":"Modal_modal__3e7zq","slide-down":"Modal_slide-down__2_cWt"};